import Component from '../colorz/Component';

export default class SubmitCartForm extends Component {
	onInit(el) {
		this.el = el;
		this.elBtnSubmit = this.el;

		this.elSpinner = this.elBtnSubmit.querySelector('.loading-overlay');
		this.elBtnText = this.elBtnSubmit.querySelector('span');
	}

	onReady() {
		this.elBtnSubmit.addEventListener('click', async (e) => {
			const isAttributesUpdated = this.elBtnSubmit.dataset.attributesUpdated;
			if (isAttributesUpdated) return; // Prevent multiple submissions if attributes are already updated

			e.preventDefault();
			e.stopPropagation();

			this.enableLoading();

			await this.updateCartAttributes();

			this.elBtnSubmit.dataset.attributesUpdated = true;
			this.elBtnSubmit.click(); // Simulate a click to submit the form
		});
	}

	enableLoading() {
		const textClass =
			this.elBtnSubmit.id === 'CartDrawer-Checkout'
				? 'u-invisible'
				: 'u-hidden';
		this.elBtnText.classList.add(textClass);
		this.elSpinner.classList.remove('u-hidden');
	}

	async updateCartAttributes() {
		let attributes = {};

		const attributesOnPage = document.querySelectorAll(
			"input[name^='attributes[item-']",
		);

		attributesOnPage.forEach((input) => {
			const name = input.name.substring(
				input.name.indexOf('[') + 1,
				input.name.lastIndexOf(']'),
			); // Extract the name from the input name
			const value = input.value;
			attributes[name] = value;
		});

		await fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({attributes}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				return data;
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}
}
